import styles from './reactivate-registration-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { CheckboxLabel, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRegistration } from '../../../_models/registration';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ReactivateRegistrationDialogProps {
  onClose: () => void,
  open: boolean,
  courseId: string,
  refreshData: () => void
}

export function ReactivateRegistrationDialog(props: ReactivateRegistrationDialogProps) {
  const { data: registration }: { data: IRegistration } = useCourseGetRequestHook(`course/registration/${props.courseId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [sendEmail, setSendEmail] = useState<boolean>(false);

  const fullName = () => {
    return registration?.person?.firstName + ' ' + registration?.person?.lastName
  }

  const handleReactivateRegistration = () => {
    setLoading(true);
    const body = {
      id: registration.id,
      person: registration.person,
      course: registration.course,
      canceled: false,
      comments: registration.comments,
      invoiceInfo: registration.invoiceInfo,
      registeredBy: registration.registeredBy,
      company: registration.company,
      sendEmail: sendEmail,
      hasAnsweredSurvey: registration.hasAnsweredSurvey,
      hasSentCertificate: registration.hasSentCertificate
    }
    makeCourseRequest(`course/Register`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('reactivateRegistration.reactivatedCourseParticipant'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('reactivateRegistration.couldNotReactivateCourseParticipant'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('reactivateRegistration.areYouSureYouWantToReactivateYourRegistration')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-2'>
          {fullName()}
        </Typography>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {registration?.person?.email}
        </Typography>
        <div className='d-inline-flex mb-3'>
          <CheckboxLabel
            label={<span>{t('reactivateRegistration.sendEmailTo')} {fullName()}</span>}
            onChange={() => setSendEmail(!sendEmail)}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='secondary'
          onClick={handleReactivateRegistration}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.reactivate')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default ReactivateRegistrationDialog;
